
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BaseService } from '../base.service';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { ClientDetails } from '@app/models/dashboard/client-details';


@Injectable({
  providedIn: 'root'
})
export class ClientDetailsService extends BaseService {

  private remindersCountSubject = new BehaviorSubject<boolean>(false);
  reminderAdded = this.remindersCountSubject.asObservable();

  private isConnectedToOpenSpaceSubject = new BehaviorSubject<boolean>(false);
  connectToOpenSpace = this.isConnectedToOpenSpaceSubject.asObservable();
  constructor(private http: HttpClient) {
    super();
  }


  isConnectedToOpenSpace(isConnected: boolean) {
    this.isConnectedToOpenSpaceSubject.next(isConnected);
  }

  updateReminderCountAdded(isReminderAdded: boolean) {
    this.remindersCountSubject.next(isReminderAdded);
  }

  getClientDetails(clientId: number, additionalDetails: boolean): Observable<ClientDetails> {
    // check if you can remove managerId
    return this.http.get<ClientDetails>(
      `${this.API_URL}/clients/${clientId}/?additionalDetails=${additionalDetails}`
    );
  }
  getCountries() {
    return this.http.get<any>(`${this.API_URL}/countries`);
  }

  postEditClientDetails(params: any): Observable<any> {
    return this.http.put<any>(
      `${this.API_URL}/clients/${params.clientId}`,
      JSON.stringify(params),
      this.httpOptions
    );
  }

  postCompanyImage(clientId: number, image: File): Observable<any> {
    const postData = new FormData();
    postData.append('file', image);
    return this.http.post<any>(
      `${this.API_URL}/clients/${clientId}/logo`,
      postData
    );
  }
  detachClient(clientId: number) {
    return this.http.delete<any>(
      `${this.API_URL}/clients/${clientId}`
    );

  }

  deleteCompanyImage(clientId: number): Observable<any> {
    return this.http.delete<any>(
      `${this.API_URL}/clients/${clientId}/logo`
    );
  }

  redirectToOpenSpace(clientId: number): Observable<any> {
    return this.http.get<any>(
      `${this.API_URL}/openspace/${clientId}/session`
    );
  }

  postRestrictAccessToKF(restrictAccessToKF: string, clientId: string): Observable<any> {
    return this.http.post(`${this.KF_API_URL}/settings/single?keyName=RestrictAccessToKF&value=${restrictAccessToKF}`, {},
    { headers: new HttpHeaders().set('clientId', clientId)});
  }

}

